module.exports = __webpack_public_path__ + "img/location-pin.6a07e1ce.svg";